import { render, staticRenderFns } from "./IssueReportDevelopmentUser.vue?vue&type=template&id=19b0e0b2&scoped=true&"
var script = {}
import style0 from "./IssueReportDevelopmentUser.vue?vue&type=style&index=0&id=19b0e0b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b0e0b2",
  null
  
)

export default component.exports